import classNames from 'classnames';
import React from 'react';
interface TabSwitcherProps {
  setChoosedMyAd: React.Dispatch<React.SetStateAction<string>>;
  choosedMyAd: string;
}
const TabSwitcher = ({choosedMyAd, setChoosedMyAd}: TabSwitcherProps) => {
  return (
    <div className="w-full text-md font-Regular text-gray-700 flex items-center border-solid border border-b-gray-500">
      <div
        className={classNames(
          'w-[50%] h-[57px] d-flex justify-center items-center ',
          {
            'text-farm-shop-500 border-b-2 border-farm-shop-500':
              choosedMyAd === 'ads',
          },
        )}
        onClick={() => setChoosedMyAd('ads')}
      >
        آگهی ها
      </div>

      <div
        className={classNames(
          'w-[50%] h-[57px] d-flex justify-center items-center',
          {
            'text-farm-shop-500 border-b-2 border-farm-shop-500':
              choosedMyAd === 'stores',
          },
        )}
        onClick={() => setChoosedMyAd('stores')}
      >
        فروشگاه ها
      </div>
    </div>
  );
};

export default TabSwitcher;
